__turbopack_context__.v({
  "FormPolicyAcceptanceField": "_25QA-a_FormPolicyAcceptanceField",
  "FormPolicyAcceptanceField__Checkbox": "_25QA-a_FormPolicyAcceptanceField__Checkbox",
  "FormPolicyAcceptanceField__Error": "_25QA-a_FormPolicyAcceptanceField__Error",
  "FormPolicyAcceptanceField__Label": "_25QA-a_FormPolicyAcceptanceField__Label",
  "FormPolicyAcceptanceField__Policy": "_25QA-a_FormPolicyAcceptanceField__Policy",
});
